export default __webpack_public_path__ + "static/media/AachalShrestha.1f42033f.png";